import { stringify } from "qs";
import fetchClient from "api/client";
import getPerPageQueryParam from "helpers/getPerPageQueryParam";
import SELLERS_ENDPOINT from "./sellersEndpoint";

/**
 * @description GET api/sellers/list
 * */
export default function getSellersList({
  queryKey: [, { page, perPage, ...queryParams }],
  signal,
}) {
  const queryString = stringify(
    {
      ...queryParams,
      page: page || 0,
      ...getPerPageQueryParam(perPage),
    },
    { addQueryPrefix: true },
  );

  return fetchClient.get(`${SELLERS_ENDPOINT}/list${queryString}`, { signal });
}
